(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EventFormDialogController', EventFormDialogController);

    EventFormDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'AlertService', 'EventForm', 'EventFormCategory', 'EventFieldDefinition', 'Principal', '$translate'];

    function EventFormDialogController($scope, $stateParams, $uibModalInstance, entity, AlertService, EventForm, EventFormCategory, EventFieldDefinition, Principal, $translate) {
        var vm = this;

        vm.eventForm = entity;
        vm.fieldDefinitionsByCode = {};
        vm.listSubCategory = [];
        vm.inputsCustomFields = [];
        vm.baseFieldConfig = defaultBaseFields();
        vm.isAdminUser = false;
        vm.hasFormValidationRight = false;
        vm.workflowStatusLocked = false;
        vm.allWorkflowStatuses = [
            {code: 'DRAFT', label: $translate.instant('wamasysApp.eventForm.statuses.DRAFT')},
            {code: 'SUBMITTED', label: $translate.instant('wamasysApp.eventForm.statuses.SUBMITTED')},
            {code: 'VALIDATED', label: $translate.instant('wamasysApp.eventForm.statuses.VALIDATED')},
            {code: 'CONTROLLED', label: $translate.instant('wamasysApp.eventForm.statuses.CONTROLLED')}
        ];
        vm.workflowStatuses = [];
        vm.changeReasons = [
            {code: 'MANUAL_CORRECTION', label: $translate.instant('wamasysApp.eventForm.reasons.MANUAL_CORRECTION')},
            {code: 'AUTO_CORRECTION', label: $translate.instant('wamasysApp.eventForm.reasons.AUTO_CORRECTION')},
            {code: 'COMPLEMENTARY_INFO_ADDED', label: $translate.instant('wamasysApp.eventForm.reasons.COMPLEMENTARY_INFO_ADDED')}
        ];

        vm.updateSubCategory = updateSubCategory;
        vm.onchangeSubCategory = onchangeSubCategory;
        vm.save = save;
        vm.saveAsDraft = saveAsDraft;
        vm.saveAndSubmit = saveAndSubmit;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.shouldShowBaseField = shouldShowBaseField;
        vm.isBaseFieldRequired = isBaseFieldRequired;
        vm.hasMissingRequiredGps = hasMissingRequiredGps;
        vm.subCategoryOptionLabel = subCategoryOptionLabel;
        vm.getSmileyOptions = getSmileyOptions;
        vm.canUseDraftSubmitActions = canUseDraftSubmitActions;
        vm.refreshWorkflowStatuses = refreshWorkflowStatuses;

        vm.eventForm.workflowStatus = vm.eventForm.workflowStatus || 'DRAFT';
        vm.eventForm.changeReason = 'MANUAL_CORRECTION';

        vm.datePickerOpenStatus = {
            dateRecord: false
        };

        Principal.identity().then(function(account) {
            var authorities = account && account.authorities ? account.authorities : [];
            vm.isAdminUser = authorities.indexOf('ROLE_ADMIN') !== -1 || authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            vm.hasFormValidationRight = authorities.indexOf('ROLE_FORM_VALIDATION') !== -1;
            vm.refreshWorkflowStatuses();
            if (vm.eventForm && vm.eventForm.subCategory && vm.eventForm.subCategory.customFields) {
                vm.onchangeSubCategory();
            }
        });

        loadFieldDefinitions();

        if (vm.eventForm && vm.eventForm.$promise) {
            vm.eventForm.$promise.then(function(result) {
                vm.eventForm.category = {id: result.categoryId, label: result.category};
                vm.eventForm.subCategory = {
                    id: result.subCategoryId,
                    label: result.subCategory,
                    versionNumber: result.subCategoryVersionNumber,
                    customFields: result.subCategoryCustomFields
                };
                vm.eventForm.workflowStatus = result.workflowStatus || 'DRAFT';
                vm.eventForm.changeReason = 'MANUAL_CORRECTION';
                vm.refreshWorkflowStatuses();
                vm.updateSubCategory();
            });
        }

        EventFormCategory.query({
            page: 0,
            size: 100
        }, onCategoryLoadSuccess, onError);

        function updateSubCategory() {
            vm.listSubCategory = [];
            vm.inputsCustomFields = [];
            vm.baseFieldConfig = defaultBaseFields();

            if (!vm.eventForm.category || !vm.eventForm.category.id) {
                return;
            }

            EventFormCategory.getListSubCategory({id: vm.eventForm.category.id}, function(result) {
                vm.listSubCategory = result;
                if (vm.eventForm.subCategory) {
                    ensureCurrentSubCategoryExists();
                }
                if (vm.listSubCategory && vm.eventForm.subCategory && vm.eventForm.subCategory.id) {
                    angular.forEach(vm.listSubCategory, function(item) {
                        if (item.id === vm.eventForm.subCategory.id) {
                            vm.eventForm.subCategory.customFields = item.customFields;
                            vm.onchangeSubCategory();
                        }
                    });
                }
            }, onError);
        }

        function onchangeSubCategory() {
            vm.inputsCustomFields = [];
            vm.baseFieldConfig = defaultBaseFields();

            if (!vm.eventForm.subCategory || !vm.eventForm.subCategory.customFields) {
                return;
            }

            try {
                var customFields = angular.fromJson(vm.eventForm.subCategory.customFields);
                vm.baseFieldConfig = resolveBaseFieldConfig(customFields);
                angular.forEach(customFields.fields || [], function(fieldConfig) {
                    var inputField = buildInputField(fieldConfig);
                    if (!inputField.hidden) {
                        vm.inputsCustomFields.push(inputField);
                    }
                });
            } catch (e) {
                vm.inputsCustomFields = [];
                vm.baseFieldConfig = defaultBaseFields();
                return;
            }

            populateInputValues(vm.eventForm.answersJson);
        }

        function save(form) {
            if (canUseDraftSubmitActions()) {
                saveAndSubmit(form);
                return;
            }
            saveWithStatus(form, vm.eventForm.workflowStatus || 'SUBMITTED');
        }

        function saveAsDraft(form) {
            saveWithStatus(form, 'DRAFT');
        }

        function saveAndSubmit(form) {
            saveWithStatus(form, 'SUBMITTED');
        }

        function saveWithStatus(form, workflowStatus) {
            if (form) {
                form.$setSubmitted();
                if (form.$invalid || vm.hasMissingRequiredGps()) {
                    return;
                }
            }

            var customFieldValues = {};
            angular.forEach(vm.inputsCustomFields, function(inputField) {
                // Une date métier est stockée sans heure ni fuseau pour rester stable sur le Web et le mobile.
                customFieldValues[inputField.storageName] = inputField.type === 'date'
                    ? formatLocalDate(inputField.value) : inputField.value;
            });

            if (!vm.eventForm.category || !vm.eventForm.category.id || !vm.eventForm.subCategory || !vm.eventForm.subCategory.id) {
                AlertService.error($translate.instant('wamasysApp.eventForm.categoryRequired'));
                return;
            }

            var payload = angular.copy(vm.eventForm);
            payload.answersJson = customFieldValues;
            payload.workflowStatus = workflowStatus || vm.eventForm.workflowStatus || 'DRAFT';
            payload.changeReason = vm.eventForm.changeReason || 'MANUAL_CORRECTION';
            payload.categoryId = vm.eventForm.category.id;
            payload.subCategoryId = vm.eventForm.subCategory.id;
            payload.category = vm.eventForm.category.label;
            payload.subCategory = vm.eventForm.subCategory.label;

            vm.isSaving = true;
            if (payload.id !== null) {
                EventForm.update(payload, onSaveSuccess, onSaveError);
            } else {
                EventForm.save(payload, onSaveSuccess, onSaveError);
            }
        }

        function canUseDraftSubmitActions() {
            return !vm.eventForm.id
                || !vm.eventForm.workflowStatus
                || vm.eventForm.workflowStatus === 'DRAFT'
                || vm.eventForm.workflowStatus === 'SUBMITTED';
        }

        function refreshWorkflowStatuses() {
            var currentStatus = vm.eventForm.workflowStatus || 'DRAFT';
            if (vm.hasFormValidationRight) {
                vm.workflowStatuses = angular.copy(vm.allWorkflowStatuses);
                if (!vm.eventForm.id) {
                    vm.workflowStatuses = vm.workflowStatuses.filter(function(status) {
                        return status.code === 'DRAFT' || status.code === 'SUBMITTED';
                    });
                }
                vm.workflowStatusLocked = false;
                return;
            }

            vm.workflowStatuses = vm.allWorkflowStatuses.filter(function(status) {
                return status.code === 'DRAFT'
                    || status.code === 'SUBMITTED'
                    || status.code === currentStatus;
            });
            vm.workflowStatusLocked = currentStatus === 'VALIDATED' || currentStatus === 'CONTROLLED';

            if (!vm.workflowStatuses.some(function(status) { return status.code === vm.eventForm.workflowStatus; })) {
                vm.eventForm.workflowStatus = 'DRAFT';
            }
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function shouldShowBaseField(fieldKey) {
            return !!(vm.baseFieldConfig[fieldKey] && vm.baseFieldConfig[fieldKey].visible);
        }

        function isBaseFieldRequired(fieldKey) {
            return !!(vm.baseFieldConfig[fieldKey] && vm.baseFieldConfig[fieldKey].visible && vm.baseFieldConfig[fieldKey].required);
        }

        function hasMissingRequiredGps() {
            if (!isBaseFieldRequired('gps')) {
                return false;
            }
            return vm.eventForm.lat === null || vm.eventForm.lat === undefined
                || vm.eventForm.lon === null || vm.eventForm.lon === undefined;
        }

        function loadFieldDefinitions() {
            EventFieldDefinition.query({
                inclInactive: false,
                page: 0,
                size: 2000,
                sort: ['fieldCode,asc']
            }, function(result) {
                angular.forEach(result, function(definition) {
                    vm.fieldDefinitionsByCode[definition.fieldCode] = definition;
                });
                if (vm.eventForm && vm.eventForm.subCategory && vm.eventForm.subCategory.customFields) {
                    vm.onchangeSubCategory();
                }
            }, function(error) {
                AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.dictionaryLoadError'));
            });
        }

        function onCategoryLoadSuccess(data) {
            vm.listCategory = data;
            if (vm.eventForm.category) {
                var index = vm.listCategory.findIndex(function(element) {
                    return element.id === vm.eventForm.category.id;
                });
                if (index === -1) {
                    vm.listCategory.push(vm.eventForm.category);
                }
            }
        }

        function ensureCurrentSubCategoryExists() {
            var index = vm.listSubCategory.findIndex(function(element) {
                return element.id === vm.eventForm.subCategory.id;
            });
            if (index === -1) {
                vm.listSubCategory.push(vm.eventForm.subCategory);
            }
        }

        function buildInputField(fieldConfig) {
            var dictionaryFieldCode = fieldConfig.dictionaryFieldCode || fieldConfig.fieldCode;
            var definition = dictionaryFieldCode ? vm.fieldDefinitionsByCode[dictionaryFieldCode] : null;
            var storageName = fieldConfig.name || fieldConfig.code || dictionaryFieldCode;
            var name = storageName ? storageName.replace(/\./g, '_') : 'field_' + vm.inputsCustomFields.length;
            var hidden = fieldConfig.hidden !== undefined && fieldConfig.hidden !== null ? !!fieldConfig.hidden : false;

            if (!hidden && !vm.isAdminUser && definition && definition.hiddenForEncoder) {
                hidden = true;
            }

            return {
                required: fieldConfig.required !== undefined && fieldConfig.required !== null ? !!fieldConfig.required : !!(definition && definition.requiredByDefault),
                hidden: hidden,
                label: fieldConfig.label || (definition ? definition.label : storageName),
                unit: fieldConfig.unit || (definition ? definition.unit : null),
                name: name,
                storageName: storageName,
                dictionaryFieldCode: dictionaryFieldCode,
                type: normalizeFieldType(definition && definition.dataType ? definition.dataType : (fieldConfig.type || 'text')),
                tooltip: fieldConfig.tooltip || (definition ? definition.description : null),
                values: resolvePossibleValues(fieldConfig, definition),
                displayOptions: buildDisplayOptions(fieldConfig.type || (definition ? definition.dataType : 'text'),
                    resolvePossibleValues(fieldConfig, definition)),
                legacyNames: parseLegacyNames(fieldConfig.legacyNames || fieldConfig.legacyCodes)
            };
        }

        function resolveBaseFieldConfig(customFields) {
            var resolved = defaultBaseFields();
            var baseFields = customFields && customFields.baseFields ? customFields.baseFields : {};

            angular.forEach(resolved, function(defaultConfig, fieldKey) {
                var current = baseFields[fieldKey] || {};
                resolved[fieldKey] = {
                    visible: current.visible !== false,
                    required: current.visible === false ? false : (current.required === true || (defaultConfig.required && current.required !== false))
                };
            });

            return resolved;
        }

        function defaultBaseFields() {
            return {
                dateRecord: {visible: true, required: true},
                title: {visible: true, required: true},
                comment: {visible: true, required: false},
                gps: {visible: true, required: false}
            };
        }

        function normalizeFieldType(type) {
            if (!type) {
                return 'text';
            }
            if (type === 'datetime') {
                return 'text';
            }
            if (type === 'ref_contrat') {
                return 'text';
            }
            return type;
        }

        function resolvePossibleValues(fieldConfig, definition) {
            var sourceType = fieldConfig.type || (definition ? definition.dataType : null);
            if (sourceType === 'satisfaction_smiley') {
                return ['very_unhappy', 'neutral', 'somewhat_happy', 'very_happy'];
            }
            if (fieldConfig.values !== undefined && fieldConfig.values !== null && fieldConfig.values !== '') {
                return splitValues(fieldConfig.values);
            }
            if (fieldConfig.valuePossibleJson) {
                return parsePossibleValuesJson(fieldConfig.valuePossibleJson);
            }
            if (definition && definition.valuePossibleJson) {
                return parsePossibleValuesJson(definition.valuePossibleJson);
            }
            return null;
        }

        function parsePossibleValuesJson(value) {
            if (!value) {
                return null;
            }
            try {
                var parsed = angular.fromJson(value);
                return angular.isArray(parsed) ? parsed : null;
            } catch (e) {
                return splitValues(value);
            }
        }

        function parseLegacyNames(value) {
            if (!value) {
                return [];
            }
            if (angular.isArray(value)) {
                return value;
            }
            return splitValues(value);
        }

        function buildDisplayOptions(fieldType, values) {
            if (fieldType !== 'satisfaction_smiley') {
                return [];
            }
            var labels = {
                very_unhappy: $translate.instant('wamasysApp.eventForm.smileys.very_unhappy'),
                neutral: $translate.instant('wamasysApp.eventForm.smileys.neutral'),
                somewhat_happy: $translate.instant('wamasysApp.eventForm.smileys.somewhat_happy'),
                very_happy: $translate.instant('wamasysApp.eventForm.smileys.very_happy')
            };
            return (values || []).map(function(value) {
                return {
                    value: value,
                    label: labels[value] || value
                };
            });
        }

        function subCategoryOptionLabel(item) {
            if (!item) {
                return '';
            }
            return item.versionNumber ? item.label + ' (v' + item.versionNumber + ')' : item.label;
        }

        function getSmileyOptions(item) {
            return item && item.displayOptions ? item.displayOptions : [];
        }

        function splitValues(value) {
            return String(value).split(/[;,]/).map(function(item) {
                return item.trim();
            }).filter(function(item) {
                return item.length > 0;
            });
        }

        function populateInputValues(rawJson) {
            if (!rawJson) {
                return;
            }
            var answers;
            try {
                answers = angular.fromJson(rawJson);
            } catch (e) {
                return;
            }

            angular.forEach(vm.inputsCustomFields, function(inputField) {
                var candidateCodes = [inputField.storageName, inputField.dictionaryFieldCode].concat(inputField.legacyNames || []);
                for (var i = 0; i < candidateCodes.length; i++) {
                    var candidateCode = candidateCodes[i];
                    if (candidateCode !== undefined && candidateCode !== null && answers[candidateCode] !== undefined) {
                        inputField.value = inputField.type === 'date'
                            ? parseIsoDate(answers[candidateCode]) : answers[candidateCode];
                        break;
                    }
                }
            });
        }

        function parseIsoDate(value) {
            if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) {
                return null;
            }
            var parts = value.split('-');
            var date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
            return date.getFullYear() === +parts[0] && date.getMonth() === +parts[1] - 1
                && date.getDate() === +parts[2] ? date : null;
        }

        function formatLocalDate(value) {
            if (!value) {
                return null;
            }
            var year = value.getFullYear();
            var month = ('0' + (value.getMonth() + 1)).slice(-2);
            var day = ('0' + value.getDate()).slice(-2);
            return year + '-' + month + '-' + day;
        }

        function onSaveSuccess(result) {
            $scope.$emit('wamasysApp:eventFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.saveError'));
        }

        function onError(error) {
            AlertService.error(error.data && error.data.message ? error.data.message : $translate.instant('wamasysApp.eventForm.technicalError'));
        }
    }
})();
